import { ThemeProvider } from "styled-components"
import "./utils/Imports"
import THEME from "./configuration/Theme"
import GlobalStyles from "./styles/globalStyles"
import { LoadProvider } from "./context/useLoadContext"
import { ErrorProvider } from "./context/useErrorContext"
import { UserProvider } from "./context/useEmployeeContext"
import { AdminEmployeeProvider } from "./context/useAdminEmployeeContext"
import { ResellerProvider } from "./context/useResellerContext"
import { MenuEmployeeProvider } from "./context/useMenuEmployeeContext"
import { ConfirmationProvider } from "./context/useConfirmationContext"
import { MenuMobileProvider } from "./context/useMenuMobileContext"
import { SignUpProvider } from "./context/useSignUpContext"
import { MessageProvider } from "./context/useMessageContext"
import { SystemModeProvider } from "./context/useSystemModeContext"
import { PublicViewProvider } from "./context/usePublicViewContext"
import { CourierViewProvider } from "./context/useCourierViewContext"
import { setOptions } from "@googlemaps/js-api-loader"
import { RoutesConfig } from "./routes/routes"
import { UpgradePlanProvider } from "./context/useUpgradePlanContext"
import { RedirectPaymentProvider } from "./context/useRedirectPayment"
import TrackingInitializer from "./analytics/TrackingInitializer"
import "./Extensions/DateExtensions"
import "./Extensions/NumberExtensions"
import { PwaInstallPrompt } from "./components/Pwa/PwaInstallPrompt"
import { PublicContactProvider } from "./context/usePublicContactContext"
import { InteractionTooltip } from "./components/InteractionTooltip/InteractionTooltip"
import { SnackbarProvider } from "./context/SnackbarProvider"

let initialized = false

export const mp = new (window as any).MercadoPago(import.meta.env.VITE_MERCADO_PAGO_PUBLIC_KEY)

export function initializeGoogleMaps() {
  if (initialized) return

  setOptions({
    key: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
    v: "weekly",
  })

  initialized = true
}

initializeGoogleMaps()

function App() {
  return (
    <ThemeProvider theme={THEME}>
      <LoadProvider>
        <ErrorProvider>
          <MessageProvider>
            <UserProvider>
              <AdminEmployeeProvider>
              <ResellerProvider>
                <MenuEmployeeProvider>
                  <ConfirmationProvider>
                    <MenuMobileProvider>
                      <SignUpProvider>
                        <CourierViewProvider>
                          <PublicContactProvider>
                            <PublicViewProvider>
                              <SystemModeProvider>
                                <UpgradePlanProvider>
                                  <RedirectPaymentProvider>
                                    <GlobalStyles />
                                    <TrackingInitializer />
                                    <div>
                                      <SnackbarProvider>
                                        <RoutesConfig />
                                        <PwaInstallPrompt />
                                        <InteractionTooltip />
                                      </SnackbarProvider>
                                    </div>
                                  </RedirectPaymentProvider>
                                </UpgradePlanProvider>
                              </SystemModeProvider>
                            </PublicViewProvider>
                          </PublicContactProvider>
                        </CourierViewProvider>
                      </SignUpProvider>
                    </MenuMobileProvider>
                  </ConfirmationProvider>
                </MenuEmployeeProvider>
              </ResellerProvider>
              </AdminEmployeeProvider>
            </UserProvider>
          </MessageProvider>
        </ErrorProvider>
      </LoadProvider>
    </ThemeProvider>
  )
}

export default App
